// Auto-generated file, scripts/set-version.js will update this file during build
export const version = '21.0.25';
export const gitHash = '6180b615a';
export const buildTime = '2026-11-05T00:01:20.778Z';
